<template>
  <div class="adminContainers">
    <div class="left">
        <div class="left-img">
            <img src="/static/img/logo_consult.png" class="l-img-logo">
            <img src="/static/img/logo_title.png" class="l-img-title">
        </div>
        <div class="left-menu">
            <div :index="item.index" v-for="item in routes" :key="item.index" v-if="!item.children" class="l-list" :class="{'actives': item.active}" @click="handleItem(item)">
                <img v-if="item.active" :src="item.isimg">
                <img v-else :src="item.noimg">
                <div>{{item.name}}</div>
            </div>
        </div>
    </div>
    <div class="adminBox">
        <header class="munuheader" style="background:#fff;">
          <div class="header-l">
              <span>弘商法律咨询后台</span>
          </div>
          <div class="header-r">
              <img :src="$avatarHash(imgs)">
              <span>{{name}}</span>
          </div>
        </header>
        <main>
            <router-view></router-view>
        </main>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'chatmunus',
  data() {
    return {
      routes1: [
        {
          name: '咨询会话',
          path: '',
          index: '/consultSession',
          isimg: '../../../static/img/consult_1.png',
          noimg: '../../../static/img/consult_11.png',
          isShow : false,
          // active:true
        },
        {
          index: '/customerRecord',
          name: '客户记录',
          isShow : false,
          isimg: '../../../static/img/consult_2.png',
          noimg: '../../../static/img/consult_22.png',
        },
      ],
      routes2: [
        {
          index: '/customerRecord',
          name: '客户记录',
          isShow : false,
          isimg: '../../../static/img/consult_2.png',
          noimg: '../../../static/img/consult_22.png',
          // active:true
        },
        {
          index: '/accountManage',
          name: '账号管理',
          isShow : false,
          isimg: '../../../static/img/consult_3.png',
          noimg: '../../../static/img/consult_33.png',
        },
      ],
      routes:[],
      activeUrl:'',
    }
  },
  computed:{
    imgs() {
      return this.$store.state.mineInfo.id;
    },
    name() {
      return this.$store.state.mineInfo.name;
    },
  },
  created() {
    if(this.$store.state.mineInfo.isSupportStaff){
      this.routes = this.routes1;
    }else{
      if(this.$store.state.mineInfo.honsen_office_clerk[0] === 1){
        this.routes = this.routes2;
      }
    }
    this.routes.forEach((item) => {
        if (item.index == this.$route.path) {
            item.active = true;
        }
    })
    
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleItem(item) {
      this.routes.forEach((e) => e.active = false)
      console.log(item)
      item.active = true;
      this.$router.push({path:item.index});
    },
  },
  mounted() {
    
  }
}
</script>

<style lang="stylus" scoepd>
.adminContainers
  height:100vh
  width:100%
  display:flex
  .left
        width:285px;
        min-width:285px;
        min-height:890px;
        height:100vh;
        background:rgba(0,84,116,1);
        border-radius:0px 60px 60px 0px;
    .left-img
        display:flex;
        flex-direction:column;
        align-items:center;
        margin-top:93px;
        .l-img-logo
            width:89px;
            height:99px;
        .l-img-title
            width:177px;
            height:33px;
            margin-top:19px;
    .left-menu
        display:flex;
        flex-direction:column;
        align-items:center;
        margin-top:45px;
        color:#ffffff;
        .l-list
            width:100%;
            height:61px;
            display:flex;
            justify-content:center;
            align-items:center;
            line-height:61px;
            text-align:center;
            font-size:22px;
            cursor:pointer;
            img
              // width:22px;
              // height:24px;
              margin-right:15px;
        .actives
            color:rgba(0,84,116,1);
            background:#ffffff;
            border-right:1px solid rgba(0,84,116,0.3)
  .adminBox
    height:100vh;
    width:calc(100% - 285px);
    background:#FEFEFF
    // display flex
    // height:calc(100vh - 80px)
    .munuheader 
        width:100%
        height 80px
        line-height 80px
        padding-left 61px
        display:flex
        justify-content:space-between
        background:#ffffff
        box-shadow:20px 4px 20px rgba(0,0,0,0.1);
        .header-l
          display:flex
          align-items:center
          img 
            vertical-align middle
            margin-right 14px
            width 50px
          span 
            vertical-align middle
            font-size 18px
            color #333
            font-weight bold
        .header-r
          display:flex
          align-items:center
          margin-right:30px
          img
            width:44px
            height:44px
            border-radius:50%
            margin-right 14px
          span
            font-size:16px
            color:#333
    main
      flex 1
      padding 60px 70px 0px 70px;
      min-width 1200px
      height:calc(100vh - 80px)
</style>


// WEBPACK FOOTER //
// src/components/consult/customer/index.vue